import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";

const ModuleSectionIntro = ({ introKey }) => {
  const { t } = useTranslation();

  return (
    <Typography
      component="p"
      sx={{
        fontSize: "14px",
        color: "text.secondary",
        lineHeight: 1.6,
        mb: 2,
      }}
    >
      {t(introKey)}
    </Typography>
  );
};

export default ModuleSectionIntro;
